import { render, staticRenderFns } from "./DetailClient.vue?vue&type=template&id=31c79ef2&scoped=true"
import script from "./DetailClient.vue?vue&type=script&lang=js"
export * from "./DetailClient.vue?vue&type=script&lang=js"
import style0 from "./DetailClient.vue?vue&type=style&index=0&id=31c79ef2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c79ef2",
  null
  
)

export default component.exports